import React, { useState } from "react";
import {
  collection,
  deleteDoc,
  getDocs,
  getFirestore,
  doc,
} from "firebase/firestore";

const ClearStocktakeScanned = () => {
  const db = getFirestore();
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  const handleClear = async () => {
    if (!window.confirm("⚠️ This will permanently delete ALL documents in stocktake_scanned. Continue?")) {
      return;
    }

    setBusy(true);
    setStatus("Deleting…");

    try {
      const snap = await getDocs(collection(db, "stocktake_scanned"));
      let count = 0;

      for (const d of snap.docs) {
        await deleteDoc(doc(db, "stocktake_scanned", d.id));
        count++;
      }

      setStatus(`Deleted ${count} documents.`);
    } catch (err) {
      console.error(err);
      setStatus("Error while deleting. Check console.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h1 className="text-xl font-semibold mb-4">Clear Stocktake Scanned</h1>
      <button
        onClick={handleClear}
        disabled={busy}
        className={`w-full py-3 rounded-md text-white ${
          busy ? "bg-gray-400" : "bg-red-600 hover:bg-red-700"
        }`}
      >
        {busy ? "Working…" : "Delete All stocktake_scanned"}
      </button>
      {status && <p className="mt-3 text-sm text-gray-700">{status}</p>}
    </div>
  );
};

export default ClearStocktakeScanned;
